import {
    type MembershipProfileAnswerWithQuestion,
    type MembershipProfileRetirementAnswer,
    type ProfileAnswer,
    QuestionKey,
    transformEnumToDisplay,
} from '@fruitful/member-profile';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { BodyMediumRegular, H6Emphasized, YStack } from 'smoothie';

import { findMembershipProfileAnswerByQuestionKey } from '../utils/memberProfileUtils';

interface MembershipInfoProps {
    membershipProfileAnswers: Array<
        MembershipProfileAnswerWithQuestion<ProfileAnswer>
    >;
}

export const MembershipRetirementTable = ({
    membershipProfileAnswers,
}: MembershipInfoProps) => {
    const retirementAnswer = findMembershipProfileAnswerByQuestionKey<
        ProfileAnswer,
        MembershipProfileRetirementAnswer
    >(membershipProfileAnswers, QuestionKey.RETIREMENT);

    return (
        <YStack gap={12}>
            <H6Emphasized>Retirement</H6Emphasized>
            {retirementAnswer == null ? (
                <BodyMediumRegular>No retirement data found.</BodyMediumRegular>
            ) : (
                <DataTable
                    value={[retirementAnswer.answer]}
                    size="small"
                    tableStyle={{ width: '100%', fontSize: 13 }}
                    scrollable
                >
                    <Column
                        field="answer"
                        header="Are you saving?"
                        body={({
                            answer,
                        }: MembershipProfileRetirementAnswer) =>
                            answer != null ? transformEnumToDisplay(answer) : ''
                        }
                    />
                    <Column
                        field="additionalInformation"
                        header="Additional info"
                    />
                </DataTable>
            )}
        </YStack>
    );
};
